<template>
  <div class="h3">Информация о туристах</div>
  <div v-if="channelManagerCode === ChannelManagerCode.Kontur" class="paragraph-s_h text-secondary mt-4">
    Укажите минимальный возраст гостя, который может проживать в вашем отеле. А&nbsp;также правило расчета данного
    возраста.
  </div>
  <div v-else class="paragraph-s_h text-secondary mt-4">
    <div>
      Укажите минимальный возраст гостя, который может проживать в вашем отеле, а&nbsp;также возрастные группы детей.
    </div>
    <div class="mt-1">
      <b>Внимание!</b> Диапазон включает нижнюю, но не включает верхнюю границу возраста. Например, диапазон 3-7
      включает в&nbsp;себя детей 3, 4, 5 и 6 лет.
    </div>
  </div>

  <tourists-types-form
    v-model="data"
    ref="formRef"
    class="mt-10"
    no-age-with-no-place
    :without-kids="channelManagerCode === ChannelManagerCode.Kontur"
  />

  <div class="d-flex justify-space-between mt-10">
    <e-btn variant="secondary" prepend-icon-src="arrowLeft" @click="back">Назад</e-btn>
    <e-btn append-icon-src="arrowRight" :loading="isLoading" variant="primary" @click="submit"> Далее </e-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import type { PVMTouristsInfo } from '@/parts/tariffs/types/tariffs';
import { EBtn } from '@/core/components/ui';
import { ChannelManagerCode } from '@/graphql/generated';
import TouristsTypesForm from '@/parts/tariffs/components/TouristsTypesForm.vue';
import { useReverseIntegrationStore } from '@/parts/tariffs/store/reverse';

const { back, integration, updateTouristsTypes, setActiveStep, channelManagerCode } = useReverseIntegrationStore();

const touristTypes = toRef(() => integration.value?.master?.steps.touristTypesSettings?.ageSettings);

const data = ref<PVMTouristsInfo>({
  touristTypes:
    touristTypes.value?.categories.values.map((type, index) => ({
      from: type.from,
      to: type.to,
      id: index,
    })) ?? [],
  ageRules: touristTypes.value?.determineAgeMethod ?? null,
  minAge: touristTypes.value?.initialAge ?? null,
  ageWithNoPlace: null,
  ageWithNoPlaceEnabled: false,
});

const formRef = ref();
const isLoading = ref(false);

const submit = async () => {
  const valid = await formRef.value?.validate();

  if (!valid) {
    return;
  }

  isLoading.value = true;

  const result = await updateTouristsTypes({
    determineAgeMethod: data.value.ageRules!,
    initialAge: data.value.minAge,
    categories: {
      values: data.value.touristTypes.map((type) => ({
        from: type.from,
        to: type.to,
      })),
    },
  });

  if (!result?.errors) {
    setActiveStep(5);
  }

  isLoading.value = false;
};
</script>

<style scoped lang="scss"></style>
